import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { initTracking, Sentry } from "@shared/utils/init-tracking";
import { reloadOnStaleChunk } from "@shared/utils/reload-on-stale-chunk";
import { ErrorView } from "@shared/components/error-view";
import { Toaster } from "@shared/components/ui/Toaster";
import { TooltipProvider } from "@shared/components/ui/Tooltip";
import { FormFactory } from "@shared/features/formv2/FormFactory";
import { SupportDrawer } from "@shared/features/support/components/support-drawer";
import { DebugDrawer } from "@shared/features/debug-drawer/debug-drawer";
import { DemoDrawer } from "@shared/features/demo-drawer/demo-drawer";
import { ResponsiveContextProvider } from "@shared/hooks/responsive/responsiveContext";

import { App } from "@/App";
import "./index.css";

const queryClient = new QueryClient();

reloadOnStaleChunk();
initTracking();

ReactDOM.createRoot(document.getElementById("root")).render(
  <Sentry.ErrorBoundary
    fallback={ErrorView}
    onReset={() => {
      window.location.reload();
    }}
  >
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ResponsiveContextProvider>
          <FormFactory>
            <TooltipProvider>
              <App />
              <Toaster />
              <DebugDrawer />
              <DemoDrawer />
              <SupportDrawer />
            </TooltipProvider>
          </FormFactory>
        </ResponsiveContextProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </Sentry.ErrorBoundary>
);
